import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

declare let gtag: (...args) => {};

@Injectable({
  providedIn: 'root'
})
export class GoogleAnalyticsService {
  private measurementIdObs: BehaviorSubject<string> = new BehaviorSubject<string>('');
  private measurementId: string;

  constructor() {
    this.initializeAnalytics();
  }

  private initializeAnalytics(): void {
    this.getMeasurementId().subscribe((id: string) => {
      this.measurementId = id;
      gtag('config', this.measurementId);
    });
  }

  setMeasurementId(measurementId: string): void {
    this.measurementIdObs.next(measurementId);
    console.log('Set Measurement ID (URL):', measurementId);
  }

  getMeasurementId(): Observable<string> {
    return this.measurementIdObs.asObservable();
  }

  sendGtagEvent(eventName: string, idenedi: string, dataObject: any): void {
    if (typeof gtag !== 'undefined' && this.measurementId) {
      gtag('event', eventName, {
        idenedi: idenedi,
        ...dataObject
      });
    } else {
      console.warn('Google Analytics not initialized or Measurement ID not set');
    }
  }
}
